import PropTypes from 'prop-types';
import { v1 as uuidv1 } from 'uuid';

export const translateQuestionTypes = (t) => ({
  SINGLE_CHOICE_QUESTION: t('CAMPAIGN.QUESTIONNAIRE.SINGLE_CHOICE_QUESTION'),
  MULTIPLE_CHOICE_QUESTION: t('CAMPAIGN.QUESTIONNAIRE.MULTIPLE_CHOICE_QUESTION'),
  OPEN_QUESTION: t('CAMPAIGN.QUESTIONNAIRE.OPEN_QUESTION'),
  RATING_QUESTION: t('CAMPAIGN.QUESTIONNAIRE.RATING_QUESTION'),
})

export const defaultQuestion = {
  name: '',
  lowGradeName: '',
  hghGradeName: '',
  options: [{
    id: uuidv1(),
    name: '',
  }],
};

export const translateQuestionsDictionary = (t) => {
  const {
    SINGLE_CHOICE_QUESTION,
    MULTIPLE_CHOICE_QUESTION,
    OPEN_QUESTION,
    RATING_QUESTION
  } = translateQuestionTypes(t);
  return {
    [SINGLE_CHOICE_QUESTION]: 'single',
    [MULTIPLE_CHOICE_QUESTION]: 'multiple',
    [OPEN_QUESTION]: 'open',
    [RATING_QUESTION]: 'rating',
  }
};

export const translateQuestionsReverseDictionary = (t) => {
  const QUESTIONS_DICTIONARY = translateQuestionsDictionary(t);
  return Object.keys(QUESTIONS_DICTIONARY).reduce(
    (obj, key) => {
      // eslint-disable-next-line no-param-reassign
      obj[QUESTIONS_DICTIONARY[key]] = key;
      return obj;
    },
    {},
  );
}

export const getQuestion = propQuestion =>
  (!propQuestion ? defaultQuestion : {
    name: propQuestion.name || defaultQuestion.name,
    options: propQuestion.options || defaultQuestion.options,
    lowGradeName: propQuestion.lowGradeName || defaultQuestion.lowGradeName,
    highGradeName: propQuestion.highGradeName || defaultQuestion.highGradeName,

    ...propQuestion,
  });

export const QuestionShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  options: PropTypes.array,
  lowGradeName: PropTypes.string,
  highGradeName: PropTypes.string,
});
